import { StyledElement, defineElement } from '@webtides/element-js';
import style from './scroller.css';

export default class Scroller extends StyledElement {
    constructor() {
        super({ styles: [style] });
    }

    connected() {
        this.updateScrollIndicators();
    }

    events() {
        return {
            this: {
                scroll: () => this.updateScrollIndicators(),
            },
        };
    }

    updateScrollIndicators() {
        const { scrollLeft, scrollWidth, clientWidth } = this;
        const canScrollLeft = scrollLeft > 0;
        const canScrollRight = scrollLeft + clientWidth < scrollWidth - 1;

        this.toggleAttribute('can-scroll-left', canScrollLeft);
        this.toggleAttribute('can-scroll-right', canScrollRight);
    }
}

defineElement('mb-scroller', Scroller);
